var scope_0 = require('/Users/marcysutton/Presentations/garbage-pail-components/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/833f24b50e98353d62dfc5ea61632fd7.js').default;export default
        Object.assign({}, scope_0 )
    